import { getPremiumCalculation } from '../../../selectors/travelKe/quote';
import { getTrallers, getTravelDetailsEmergency } from '../../../selectors/travelKe/travelDetails';
import { getNetworkProvider } from '../../../selectors/travelKe/payments';
import { getIsApiPending } from '../../../selectors/travelKe/payloadCollection';
import {
    apiTransitionPayloadCollection,
    submitPayloadDataSuccess,
    submitPayloadDataFailure,
} from '../../../actions/travelKe/payloadCollection';
import { getAccessToken } from '../../../selectors/travelKe/payments';
import axios from 'axios';
import { triggerBankDetails } from '../../../actions/travelKe/payments';
import { getAgentForm } from '../../../selectors/travelKe/travelAgentModal';

export const payloadSubmitService = (store, next, action) => {
    const networkProvider = getNetworkProvider(store.getState());

    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                const resp = await calculate(store.getState());

                store.dispatch(submitPayloadDataSuccess(resp.data));
                store.dispatch(apiTransitionPayloadCollection.success());

                // if (networkProvider.value !== 'mpesa') {
                //     store.dispatch(triggerBankDetails());
                // }
            } catch (e) {
                console.error(e);
                store.dispatch(submitPayloadDataFailure(e));
                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
    })();
    return next(action);
};

function convertDateFormat(dateString) {
    // Split the date string into day, month, and year
    var parts = dateString.split('/');

    // Rearrange the parts into the desired format
    var formattedDate = parts[2] + '-' + parts[1].padStart(2, '0') + '-' + parts[0].padStart(2, '0');

    return formattedDate;
}

function getFirstAndLastName(fullName) {
    // Split the full name into an array of strings
    var names = fullName.trim().split(' ');

    // Extract the first name (first element of the array)
    var firstName = names[0];

    // Extract the last name (last element of the array)
    var lastName = names[names.length - 1];

    // Return an object containing the first and last names
    return {
        firstName: firstName,
        lastName: lastName,
    };
}

const payloadCollection = (state) => {
    const travelDetails = getTrallers(state);
    const emergencyContact = getTravelDetailsEmergency(state);
    const premium = getPremiumCalculation(state);
    const agent = getAgentForm(state);

    const agentPayload = {
        countryCode: 'KE',
        referrerCode: agent.agentCode.value || 'NA',
        referrerType: agent.intermediaryType.value || 'NA',
    };

    const travellers = travelDetails.map((item) => ({
        id: null,
        title: item.title.value,
        fullName: item.fullName.value,
        dateOfBirth: item.dob.value,
        // ageBand: item.ageBand.value,
        // idType: item.idType.value,
        idNumber: item.idNumber.value,
        kraPin: item.kraNumber.value,
        emailAddress: item.email.value,
        phoneNumber: item.phoneNumber.value,
        passportNo: item.passport.value,
        kraPinDoc: item.kraPinDoc.value.base64File,
        idNumberDoc: item.idDoc.value.base64File,
        passportNoDoc: item.passportDoc.value.base64File,
    }));

    const payload = {
        travellers,
        emergencyContact: {
            fullName: emergencyContact.fullName.value,
            emailAddress: emergencyContact.email.value,
            phoneNumber: emergencyContact.phoneNumber.value,
        },
        quoteId: premium.value?.id,
    };

    return {
        ...payload,
        ...agentPayload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-travel-insurance/submit-payload';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
